module.exports = __webpack_public_path__ + "images/pro/img-pro-service@2x-65f7f37671d279765f33d88002da1a66.png";